module.exports = __webpack_public_path__ + "img/479.13fab64a.png";